import React, { useState } from 'react';
import axios from 'axios';
import { Box, Button, Container, InputAdornment, InputBase, Paper, Typography, Alert, } from "@mui/material";
import logo from "../../assests/logo.png";
import ellipse1 from "../../assests/Ellipse 1.png";
import ellipse2 from "../../assests/Ellipse 2.png";
import { Link } from 'react-router-dom';
import useRecaptcha from '../../hooks/useRecaptcha';

const ForgotPassword = () => {
  const { executeRecaptcha } = useRecaptcha();

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const recaptchaValue = await executeRecaptcha('forgot_password');
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/forgot-password`, { email, recaptchaValue });
      setMessage(response.data.message);
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong');
      setMessage('');
    }
  };

  return (
    <Box sx={{ width: "100%", height: "100vh", position: "relative", overflow: "hidden", bgcolor: "#010B2B", }} >
      {/* Background elements */}
      <Box component="img" src={ellipse1} alt="Background shape"
        sx={{ position: "absolute", width: "840px", height: "840px", top: 0, right: 0, }} />
      <Box component="img" src={ellipse2} alt="Background shape"
        sx={{ position: "absolute", width: "810px", height: "812px", top: "212px", left: 0, }} />

      {/* Logo */}
      <Box component="div" sx={{
        position: "absolute", width: "225px", height: "59px", top: "49px", left: "102px",
        backgroundImage: `url(${logo})`, backgroundSize: "cover", backgroundPosition: "center",
      }} />

      {/* Main content */}
      <Container maxWidth="lg" sx={{ height: "100%" }}>
        <Box display="flex" justifyContent="center" alignItems="center" height="100%" >
          <Paper elevation={0}
            sx={{
              width: "570px", padding: "40px 56px", display: "flex", flexDirection: "column",
              alignItems: "center", gap: "41px", backgroundColor: "rgba(202, 202, 202, 0.23)",
              backdropFilter: "blur(2px)", borderRadius: "12px", border: "2px solid white", position: "relative", zIndex: 1,
            }} >
            <Box
              sx={{ width: "100%", maxWidth: "453px", display: "flex", flexDirection: "column", alignItems: "center", gap: "30px", }} >
              <Typography variant="h4" component="h1"
                sx={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, color: "white", textAlign: "center", width: "100%", }} >
                Forgot Password
              </Typography>

              {message && (
                <Alert severity="success" sx={{ width: '100%' }}>
                  {message}
                </Alert>
              )}

              {error && (
                <Alert severity="error" sx={{ width: '100%' }}>
                  {error}
                </Alert>
              )}

              <Box component="form" onSubmit={handleSubmit}
                sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "34px", }} >
                <Box sx={{ width: "100%" }}>
                  <Typography sx={{ fontFamily: "'Inter', sans-serif", color: "#DBD6D6", fontSize: "16px", mb: 1, }} > Email Address </Typography>
                  <InputBase fullWidth value={email} onChange={handleEmailChange}
                    sx={{
                      height: "35px", backgroundColor: "rgba(255, 255, 255, 0.27)", borderRadius: "8px", padding: "0 12px", color: "white",
                      "& .MuiInputBase-input": {
                        height: "35px",
                      },
                    }}
                    endAdornment={<InputAdornment position="end">
                      <Box sx={{ borderLeft: "1px solid rgba(102, 102, 102, 0.44)", paddingLeft: "6px", color: "#938F8F", fontFamily: "'Inter', sans-serif", fontSize: "16px", }} ></Box>
                    </InputAdornment>
                    } />
                </Box>
                <Button type="submit" variant="contained" fullWidth
                  sx={{
                    height: "50px", backgroundColor: "#2D55FB", borderRadius: "12px", fontFamily: "'Inter', sans-serif", fontWeight: 500,
                    fontSize: "22px", textTransform: "none", "&:hover": { backgroundColor: "#1A41E6", },
                  }} >
                  Send Reset Link
                </Button>
                <Box sx={{ textAlign: 'center', mt: 2 }}>
                <Typography variant="body2" sx={{ color: 'lightgray' }}>
                  {' '}
                  <Link to="/" style={{ color: '#FFFFFF', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
                  ← Back to Login
                  </Link>
                </Typography>
              </Box>
              </Box>
            </Box>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};

export default ForgotPassword;
